module.exports = __webpack_public_path__ + "src/assets/templates/Members-Import-Template.xlsx";